import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { calcLegacyTheme } from '../../lib/calc-legacy-theme';
import { AccessItemCtaComponent } from '../access-item-cta/access-item-cta.component';
import { AccessItemHeaderComponent } from '../access-item-header/access-item-header.component';
import { AccessItemIconComponent } from '../access-item-icon/access-item-icon.component';
import { AccessItemComponent } from '../access-item/access-item.component';
import { GallerySettingsIconComponent } from '../gallery-settings-icon/gallery-settings-icon.component';

@Component({
  selector: 'app-theme-asset-page-item',
  imports: [
    ButtonDirective,
    AccessItemComponent,
    AccessItemIconComponent,
    GallerySettingsIconComponent,
    AccessItemHeaderComponent,
    AccessItemCtaComponent,
    SvgComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-asset-page-item.component.html',
  styleUrl: './theme-asset-page-item.component.scss',
})
export class ThemeAssetPageItemComponent {
  gallery = input.required<GalleryDto>();
  customize = output<void>();
  theme = computed(() => {
    const gallery = this.gallery();
    if (!gallery) return;
    return this.gallery().theme || calcLegacyTheme(this.gallery());
  });
}
